import { Component, OnInit, Input } from '@angular/core';
import { configSections } from 'src/app/profile-config/services/user-config-panel.service';
import { HistorialService } from 'src/app/historial/services/historial.service';

@Component({
  selector: 'app-user-history-config',
  templateUrl: './user-history-config.component.html',
  styleUrls: ['./user-history-config.component.scss', './../components-conf.scss']
})
export class UserHistoryConfigComponent implements OnInit {
  @Input() filterOptionsBy : string = ""

  public configSections = configSections;
  
  constructor(
    public historialService : HistorialService
  ) { }

  ngOnInit(): void {
    console.log("configuracion de usuario historial", this.historialService)
  }

}
